import axios from '../../../../utils/request';
function GET_LIST(params) {
    return axios.post("/statistics/Statistics/general",{ ...params } )
}
function GET_LIST_CHANGE(params) {
    return axios.post("/statistics/Statistics/generalAjax",{ ...params } )
}

export default {
    GET_LIST,
    GET_LIST_CHANGE


};